/**
 * Constantes de permisos del sistema (códigos alineados con `Permission` en BD, formato MODULE.ACTION en mayúsculas).
 * Deben coincidir con el payload de permisos del API tras la normalización RBAC.
 */

export const PERMISSIONS = {
  MATERIAL_REQUEST: {
    CREATE: "MATERIALREQUEST.CREATE",
    READ: "MATERIALREQUEST.READ",
    APPROVE: "MATERIALREQUEST.APPROVE",
    REJECT: "MATERIALREQUEST.REJECT",
    CONFIRM_LOADING: "MATERIALREQUEST.CONFIRMLOADING",
    CONFIRM_DEPARTURE: "MATERIALREQUEST.CONFIRMDEPARTURE",
    UPDATE_TRANSIT: "MATERIALREQUEST.UPDATETRANSIT",
    CONFIRM_DELIVERY: "MATERIALREQUEST.CONFIRMDELIVERY",
    CANCEL: "MATERIALREQUEST.CANCEL",
    UPDATE: "MATERIALREQUEST.UPDATE",
    VIEW_STOCK_INFO: "MATERIALREQUEST.VIEWSTOCKINFO",
  },

  APPROVAL_FLOW: {
    CREATE: "APPROVAL_FLOW.CREATE",
    READ: "APPROVAL_FLOW.READ",
    UPDATE: "APPROVAL_FLOW.UPDATE",
    DELETE: "APPROVAL_FLOW.DELETE",
  },

  MATERIAL_MOVEMENT: {
    CREATE: "MATERIALMOVEMENT.CREATE",
    READ: "MATERIALMOVEMENT.READ",
    UPDATE: "MATERIALMOVEMENT.UPDATE",
    DELETE: "MATERIALMOVEMENT.DELETE",
    EXPORT: "MATERIALMOVEMENT.EXPORT",
    APPROVE: "MATERIALMOVEMENT.APPROVE",
    REJECT: "MATERIALMOVEMENT.REJECT",
  },

  MATERIALS: {
    CREATE: "MATERIAL.CREATE",
    READ: "MATERIAL.READ",
    READ_SINGLE: "MATERIAL.READ",
    UPDATE: "MATERIAL.UPDATE",
    DELETE: "MATERIAL.DELETE",
  },

  MATERIAL_UNIT_CONVERSIONS: {
    CREATE: "MATERIAL_UNIT_CONVERSION.CREATE",
    READ: "MATERIAL_UNIT_CONVERSION.READ",
    READ_SINGLE: "MATERIAL_UNIT_CONVERSION.READ",
    UPDATE: "MATERIAL_UNIT_CONVERSION.UPDATE",
    DELETE: "MATERIAL_UNIT_CONVERSION.DELETE",
  },

  MATERIAL_GROUPS: {
    CREATE: "MATERIALGROUP.CREATE",
    READ: "MATERIALGROUP.READ",
    UPDATE: "MATERIALGROUP.UPDATE",
    DELETE: "MATERIALGROUP.DELETE",
  },

  MATERIAL_TYPES: {
    READ: "MATERIAL.READ",
  },

  MOVEMENT_TYPE: {
    CREATE: "MOVEMENTTYPE.CREATE",
    READ: "MOVEMENTTYPE.READ",
    UPDATE: "MOVEMENTTYPE.UPDATE",
    DELETE: "MOVEMENTTYPE.DELETE",
  },

  PRODUCTION_ORDER: {
    CREATE: "PRODUCTIONORDER.CREATE",
    READ: "PRODUCTIONORDER.READ",
    UPDATE: "PRODUCTIONORDER.UPDATE",
    DELETE: "PRODUCTIONORDER.DELETE",
  },

  COST_CENTER: {
    CREATE: "COSTCENTER.CREATE",
    READ: "COSTCENTER.READ",
    UPDATE: "COSTCENTER.UPDATE",
    DELETE: "COSTCENTER.DELETE",
  },

  PLANT: {
    CREATE: "PLANT.CREATE",
    READ: "PLANT.READ",
    UPDATE: "PLANT.UPDATE",
    DELETE: "PLANT.DELETE",
  },

  PLANT_TYPES: {
    CREATE: "PLANTTYPE.CREATE",
    READ: "PLANTTYPE.READ",
    UPDATE: "PLANTTYPE.UPDATE",
    DELETE: "PLANTTYPE.DELETE",
  },

  STORAGE_LOC: {
    CREATE: "STORAGELOC.CREATE",
    READ: "STORAGELOC.READ",
    UPDATE: "STORAGELOC.UPDATE",
    DELETE: "STORAGELOC.DELETE",
  },

  UNITS: {
    CREATE: "UNIT.CREATE",
    READ: "UNIT.READ",
    UPDATE: "UNIT.UPDATE",
    DELETE: "UNIT.DELETE",
  },

  BATCH: {
    CREATE: "BATCH.CREATE",
    READ: "BATCH.READ",
    UPDATE: "BATCH.UPDATE",
    DELETE: "BATCH.DELETE",
  },

  BATCH_TEMPLATE: {
    CREATE: "BATCHTEMPLATE.CREATE",
    READ: "BATCHTEMPLATE.READ",
    UPDATE: "BATCHTEMPLATE.UPDATE",
    DELETE: "BATCHTEMPLATE.DELETE",
  },

  CARRIER: {
    CREATE: "CARRIER.CREATE",
    READ: "CARRIER.READ",
    UPDATE: "CARRIER.UPDATE",
    DELETE: "CARRIER.DELETE",
  },

  CARRIER_TYPE: {
    CREATE: "CARRIERTYPE.CREATE",
    READ: "CARRIERTYPE.READ",
    UPDATE: "CARRIERTYPE.UPDATE",
    DELETE: "CARRIERTYPE.DELETE",
  },

  VENDOR: {
    CREATE: "VENDOR.CREATE",
    READ: "VENDOR.READ",
    UPDATE: "VENDOR.UPDATE",
    DELETE: "VENDOR.DELETE",
  },

  CUSTOMER: {
    CREATE: "CUSTOMER.CREATE",
    READ: "CUSTOMER.READ",
    UPDATE: "CUSTOMER.UPDATE",
    DELETE: "CUSTOMER.DELETE",
  },

  PAYMENT_TERM: {
    CREATE: "PAYMENTTERM.CREATE",
    READ: "PAYMENTTERM.READ",
    UPDATE: "PAYMENTTERM.UPDATE",
    DELETE: "PAYMENTTERM.DELETE",
  },

  COMMERCIAL_BUSINESS_LINE: {
    CREATE: "COMMERCIALBUSINESSLINE.CREATE",
    READ: "COMMERCIALBUSINESSLINE.READ",
    UPDATE: "COMMERCIALBUSINESSLINE.UPDATE",
    DELETE: "COMMERCIALBUSINESSLINE.DELETE",
  },

  DOCUMENT_CLASS: {
    CREATE: "DOCUMENTCLASS.CREATE",
    READ: "DOCUMENTCLASS.READ",
    UPDATE: "DOCUMENTCLASS.UPDATE",
    DELETE: "DOCUMENTCLASS.DELETE",
  },

  VENDOR_SERVICE: {
    CREATE: "VENDORSERVICE.CREATE",
    READ: "VENDORSERVICE.READ",
    UPDATE: "VENDORSERVICE.UPDATE",
    DELETE: "VENDORSERVICE.DELETE",
  },

  PURCHASE_ORDER: {
    CREATE: "PURCHASEORDER.CREATE",
    READ: "PURCHASEORDER.READ",
    UPDATE: "PURCHASEORDER.UPDATE",
    DELETE: "PURCHASEORDER.DELETE",
    RELEASE: "PURCHASEORDER.RELEASE",
    APPROVE: "PURCHASEORDER.APPROVE",
    REJECT: "PURCHASEORDER.REJECT",
    CANCEL: "PURCHASEORDER.CANCEL",
    RELEASE_RETENTION: "PURCHASEORDER.RELEASE_RETENTION",
  },

  SALES_ORDER: {
    CREATE: "SALESORDER.CREATE",
    READ: "SALESORDER.READ",
    UPDATE: "SALESORDER.UPDATE",
    DELETE: "SALESORDER.DELETE",
    RELEASE: "SALESORDER.RELEASE",
    APPROVE: "SALESORDER.APPROVE",
    REJECT: "SALESORDER.REJECT",
    CANCEL: "SALESORDER.CANCEL",
  },

  DISPATCH_GUIDE: {
    READ: "MATERIALMOVEMENT.READ",
    UPDATE: "MATERIALMOVEMENT.UPDATE",
    DELETE: "MATERIALMOVEMENT.DELETE",
  },

  STOCK: {
    READ: "MATERIALMOVEMENT.READ",
  },

  DASHBOARD: {
    READ: "MATERIALMOVEMENT.READ",
  },

  WORK_ORDER: {
    CREATE: "WORKORDER.CREATE",
    READ: "WORKORDER.READ",
    UPDATE: "WORKORDER.UPDATE",
    DELETE: "WORKORDER.DELETE",
    APPROVE: "WORKORDER.APPROVE",
    POST_INVENTORY: "WORKORDER.POSTINVENTORY",
  },

  WORK_ORDER_TEMPLATE: {
    CREATE: "WORKORDERTEMPLATE.CREATE",
    READ: "WORKORDERTEMPLATE.READ",
    UPDATE: "WORKORDERTEMPLATE.UPDATE",
    DELETE: "WORKORDERTEMPLATE.DELETE",
    CONFIGURE_FORMS: "WORKORDERTEMPLATE.CONFIGUREFORMS",
  },

  WORK_ORDER_ACTIVITY: {
    CREATE: "WORKORDERACTIVITY.CREATE",
    READ: "WORKORDERACTIVITY.READ",
    UPDATE: "WORKORDERACTIVITY.UPDATE",
    DELETE: "WORKORDERACTIVITY.DELETE",
  },

  INDUSTRIAL_FORMULA: {
    CREATE: "INDUSTRIALFORMULA.CREATE",
    READ: "INDUSTRIALFORMULA.READ",
    UPDATE: "INDUSTRIALFORMULA.UPDATE",
    DELETE: "INDUSTRIALFORMULA.DELETE",
  },

  LABOR_ACTIVITY: {
    CREATE: "LABOR_ACTIVITY.CREATE",
    READ: "LABOR_ACTIVITY.READ",
    UPDATE: "LABOR_ACTIVITY.UPDATE",
    DELETE: "LABOR_ACTIVITY.DELETE",
  },

  LABOR_RATE: {
    CREATE: "LABOR_RATE.CREATE",
    READ: "LABOR_RATE.READ",
    UPDATE: "LABOR_RATE.UPDATE",
    DELETE: "LABOR_RATE.DELETE",
  },

  LABOR_RATE_GENERAL: {
    CREATE: "LABOR_RATE_GENERAL.CREATE",
    READ: "LABOR_RATE_GENERAL.READ",
    UPDATE: "LABOR_RATE_GENERAL.UPDATE",
    DELETE: "LABOR_RATE_GENERAL.DELETE",
  },

  SPECIES: {
    CREATE: "SPECIES.CREATE",
    READ: "SPECIES.READ",
    UPDATE: "SPECIES.UPDATE",
    DELETE: "SPECIES.DELETE",
  },

  VARIETY: {
    CREATE: "VARIETY.CREATE",
    READ: "VARIETY.READ",
    UPDATE: "VARIETY.UPDATE",
    DELETE: "VARIETY.DELETE",
  },

  LABOR_TICKET: {
    CREATE: "LABOR_TICKET.CREATE",
    READ: "LABOR_TICKET.READ",
    UPDATE: "LABOR_TICKET.UPDATE",
    DELETE: "LABOR_TICKET.DELETE",
    CONFIRM: "LABOR_TICKET.CONFIRM",
  },

  LABOR_RETENTION: {
    CREATE: "LABOR_RETENTION.CREATE",
    READ: "LABOR_RETENTION.READ",
    UPDATE: "LABOR_RETENTION.UPDATE",
    DELETE: "LABOR_RETENTION.DELETE",
  },

  /** Rutas (maestro de puntos). */
  ROUTE: {
    CREATE: "ROUTE.CREATE",
    READ: "ROUTE.READ",
    UPDATE: "ROUTE.UPDATE",
    DELETE: "ROUTE.DELETE",
  },

  /** Viajes (planificación y ejecución). */
  TRIP: {
    CREATE: "TRIP.CREATE",
    READ: "TRIP.READ",
    UPDATE: "TRIP.UPDATE",
    DELETE: "TRIP.DELETE",
    /** Ejecutar viaje (iniciar/finalizar/cancelar). */
    EXECUTE: "TRIP.EXECUTE",
  },

  /** Usuarios de plataforma (Core / modo SYSTEM). */
  USER: {
    CREATE: "USER.CREATE",
    READ: "USER.READ",
    UPDATE: "USER.UPDATE",
    DELETE: "USER.DELETE",
  },

  /** Personas operativas (Tenant / membresía sociedad). */
  USER_COMPANY: {
    CREATE: "USERCOMPANY.CREATE",
    READ: "USERCOMPANY.READ",
    UPDATE: "USERCOMPANY.UPDATE",
    DELETE: "USERCOMPANY.DELETE",
  },
} as const;

/**
 * Permisos de identidad (CRUD usuario). No mezclar con USER_COMPANY en el mismo check.
 * Ver: business/users-vs-usercompany.mdc
 */
export const USER_IDENTITY_PERMISSIONS = {
  CREATE: PERMISSIONS.USER.CREATE,
  READ: PERMISSIONS.USER.READ,
  UPDATE: PERMISSIONS.USER.UPDATE,
  DELETE: PERMISSIONS.USER.DELETE,
} as const;

/**
 * Permisos de membresía sociedad (UserCompany / assign). Solo flujos de asociación.
 */
export const USER_COMPANY_MEMBERSHIP_PERMISSIONS = {
  CREATE: PERMISSIONS.USER_COMPANY.CREATE,
  READ: PERMISSIONS.USER_COMPANY.READ,
  UPDATE: PERMISSIONS.USER_COMPANY.UPDATE,
  DELETE: PERMISSIONS.USER_COMPANY.DELETE,
} as const;

/** @deprecated Usar USER_IDENTITY_PERMISSIONS o USER_COMPANY_MEMBERSHIP_PERMISSIONS */
export const PERSONAS_PERMISSIONS = {
  CREATE: [PERMISSIONS.USER.CREATE],
  READ: [PERMISSIONS.USER.READ],
  UPDATE: [PERMISSIONS.USER.UPDATE],
  DELETE: [PERMISSIONS.USER.DELETE],
} as const;

/**
 * OR documentado para user-assignment (SYSTEM → USER.*; TENANT → USERCOMPANY.*).
 * Usar con hasPermission(USER_ASSIGNMENT_PERMISSIONS.WRITE) — no mezclar en canSave CRUD.
 */
export const USER_ASSIGNMENT_PERMISSIONS = {
  READ: [PERMISSIONS.USER.READ, PERMISSIONS.USER_COMPANY.READ] as const,
  WRITE: [PERMISSIONS.USER.UPDATE, PERMISSIONS.USER_COMPANY.UPDATE] as const,
};

export type PermissionCode =
  (typeof PERMISSIONS)[keyof typeof PERMISSIONS][keyof (typeof PERMISSIONS)[keyof typeof PERMISSIONS]];
